import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Sample } from '../models/sample';

import { MessagesService } from '../messages/messages.service';
import { Plate } from "../models-new/plate";

@Component({
    selector: 'app-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.css']
})
export class GridComponent implements OnInit {

    multiSelectionMode: boolean = false;
    selectedCells: Set<string> = new Set();
    showSampleComment = false;
    selectedLabID: string;
    puid: string;

    @Input() sampleBarcodeMap = new Map();
    @Input() selectedPlate: Plate;
    @Input() plateSamplesMap = new Map();
    @Input() selectedCell = "A01"
    @Input() isQcScreen: boolean;
    @Input() allowMultiSelect: boolean;

    @Output() selectedGridCell = new EventEmitter<string>();
    @Output() selectedGridCells = new EventEmitter<Array<{ position: string, sampleId: string }>>();
    @Output() selectedCellPopUp = new EventEmitter<string>();

    rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    formattedColumnHeaders: string[];
    skyBlueColor = "#9cd1e6";
    colorMap = {
        "#9cd1e6":"selected-cell",
        "#90ee90":"cell-with-value",
        "#f26162":"is-qc-fail",
        "#ffa500":"is-qc-switch"
    }

    constructor(private readonly _messagesService: MessagesService) { }

    ngOnInit() {
        this.selectedLabID = JSON.parse(localStorage.getItem('lab') || '{"lab":{"_id":""}}').lab._id;
		this.puid = localStorage.getItem('PUID');
        this.formattedColumnHeaders = this.columnHeaders.map(num => num.toString().padStart(2, '0'));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['allowMultiSelect']) {
            this.multiSelectionMode = this.allowMultiSelect;
            this.selectedCells.clear();
        }
    }

    prepareDataForMultiSelect(): Array<{ position: string, sampleId: string }> {
        return Array.from(this.selectedCells).map(cell => {
            return {
                position: cell,
                sampleId: this.sampleBarcodeMap.get(cell)
            }
        })
    }

    selectTableCell(row: number, col: number) {
        if (this.multiSelectionMode) {
            this.handleMultiSelection(row, col);
        }
        else if (this.selectedPlate.plateID != undefined || this.selectedPlate.plateID != null) {
            if(this.getRowColStringFromPos(row, col) === this.selectedCell && this.sampleBarcodeMap.has(this.selectedCell)){
                this.showSampleComment = true;
            }else{
                this.selectedCell = this.getRowColStringFromPos(row, col);
                let selectedCell = this.selectedCell
                this.selectedGridCell.emit(this.selectedCell);
                if (this.sampleBarcodeMap.has(selectedCell)) {
                    this._messagesService.addWarningMessage({
                        severity: "warn", summary: "Sample already present",
                        detail: "Please choose a different cell or click again to add comment for sample"
                    })
                }
                else {
                    this._messagesService.addWarningMessage({
                        severity: "warn", detail: "No Sample in the selected cell!",
                    })
                }
            }
        }
        else {
            this.selectedCell = 'A01';
        }
        if (this.isQcScreen) {
            this.selectedCellPopUp.emit(this.selectedCell);
        }
    }

    private handleMultiSelection(row: number, col: number) {
        if (this.isCellSelected(row, col)) {
            this.selectedCells.delete(this.getRowColStringFromPos(row, col));
            this.selectedGridCells.emit(this.prepareDataForMultiSelect());
        }
        else if (!this.sampleBarcodeMap.has(this.getRowColStringFromPos(row, col))) {
            this._messagesService.addWarningMessage({
                severity: "warn", summary: "Sample not present",
                detail: "Please choose a different cell"
            });
        }
        else {
            this.selectedCells.add(this.getRowColStringFromPos(row, col));
            this.selectedGridCells.emit(this.prepareDataForMultiSelect());
        }
    }

    getSampleAt(row: number, col: number) {
        let positionString = this.getRowColStringFromPos(row, col);
        if (this.plateSamplesMap.has(positionString)) {
            return this.plateSamplesMap.get(positionString);
        }
        let sample = new Sample();
        sample.sampleID = '';
        return sample;
    }

    getRowColStringFromPos(row: number, col: number) {
        return this.rowHeaders[row] + this.formattedColumnHeaders[col];
    }

    isCellHighlighted(cell: string): boolean {
        return cell === this.selectedCell;
    }

    isCellSelected(row: number, col: number) {
        let position = this.getRowColStringFromPos(row, col);
        return this.selectedCells.has(position);
    }

    determineCellColorValue(row: number, col: number){
        if(!this.isQcScreen){
            return this.getSampleAt(row, col).sampleID !== "" ? "cell-with-value" : "";
        }
        return this.colorMap[this.getSelectedCellBackgroundColor(row, col)] ?? ""
    }

    getSelectedCellBackgroundColor(row: number, col: number) {
        const positionString = this.getRowColStringFromPos(row, col);

        if (this.isCellHighlighted(positionString)) {
            return this.skyBlueColor;
        }
        if (this.isQcScreen && this.plateSamplesMap.has(positionString)) {
            return this.plateSamplesMap.get(positionString).color;
        }
    }

    getSampleCommentsDialogHeader(){
        return `Sample: ${this.sampleBarcodeMap.get(this.selectedCell)} comments`;
      }

}


